import { render, staticRenderFns } from "./BasePDFRenderExamReview.vue?vue&type=template&id=a0127e60&scoped=true&"
import script from "./BasePDFRenderExamReview.vue?vue&type=script&lang=js&"
export * from "./BasePDFRenderExamReview.vue?vue&type=script&lang=js&"
import style0 from "./BasePDFRenderExamReview.vue?vue&type=style&index=0&id=a0127e60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0127e60",
  null
  
)

export default component.exports